module.exports = __webpack_public_path__ + "img/pdf.3026ea74.jpg";